"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UserProfileStore_1 = require("../model/UserProfileStore");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
// Basic container for components that request a user profile before rendering
var UserContainer = /** @class */ (function (_super) {
    __extends(UserContainer, _super);
    function UserContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return _this.props.onRenderUser(UserProfileStore_1.UserProfileStore.value);
        };
        return _this;
    }
    UserContainer.prototype.componentWillMount = function () {
        UserProfileStore_1.UserProfileStore.load();
    };
    UserContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: UserProfileStore_1.UserProfileStore.sync, onRenderDone: this._onRenderDone, onRenderSync: this.props.onRenderLoadingUserProfile, onRenderError: this.props.onRenderLoadError });
    };
    return UserContainer;
}(React.Component));
exports.UserContainer = UserContainer;
